import { render, staticRenderFns } from "./NewCountry-list.vue?vue&type=template&id=d1210e78"
import script from "./NewCountry-list.vue?vue&type=script&lang=js"
export * from "./NewCountry-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports